import {CurrencyPipe, DatePipe, TitleCasePipe} from '@angular/common';
import {NgModule} from '@angular/core';
import {DisplayOptionalPipe} from '@app/pipes/display-optional.pipe';
import {EnumPipe} from '@app/pipes/enum.pipe';

@NgModule({
  declarations: [EnumPipe, DisplayOptionalPipe],
  imports: [],
  exports: [
    EnumPipe,
    DisplayOptionalPipe
  ],
  providers: [
    EnumPipe,
    DatePipe,
    TitleCasePipe,
    DisplayOptionalPipe,
    CurrencyPipe
  ]
})
export class PipesModule {
}
